import React from 'react';
import ViewToggle from './ViewToggle';
import { useTheme } from '../context/ThemeContext';
import { THEMES } from '../themeConstants';

const ExplorerToolbar = ({ viewMode, breadcrumb, onViewModeChange, onBreadcrumbClick }) => {
  const { colors, theme, toggleTheme } = useTheme();



  return (
    <div className="hidden lg:block relative flex-shrink-0">
      <div
        className="absolute bottom-0 left-0 right-0 h-0"
        style={{
          borderBottom: `1px dashed ${colors.border}`,
          borderImageSource: `repeating-linear-gradient(to right, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px)`,
          borderImageSlice: 1
        }}
      ></div>
      <div className="flex items-center px-4 py-2">
        {/* Breadcrumb for icon view */}
        {viewMode === 'icon' && (
          <div className="flex items-center gap-2 text-[16px]" style={{ color: colors.textSecondary }}>
            <button
              onClick={() => onBreadcrumbClick(-1)}
              className="hover:underline cursor-pointer"
              style={{ color: colors.textSecondary }}
            >
              Root
            </button>
            {breadcrumb.map((folder, index) => (
              <div key={index} className="flex items-center gap-2">
                <span>/</span>
                <button
                  onClick={() => onBreadcrumbClick(index)}
                  className="hover:underline cursor-pointer"
                  style={{ color: colors.textSecondary }}
                >
                  {folder}
                </button>
              </div>
            ))}
          </div>
        )}
        <div className="ml-auto flex items-center gap-4">
          <ViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
        </div>
      </div>
    </div>
  );
};

export default ExplorerToolbar;
